import { ExtraFormField } from '@common/types/api';

/**
 * Password fields to inject when event uses email+password authentication
 * These fields will be inserted after the 'email' field
 */
export const PASSWORD_EXTRA_FIELDS: ExtraFormField[] = [
  {
    id: 'extra_password',
    name: 'password',
    label: 'Senha',
    type: 'password',
    placeholder: 'Digite sua senha',
    is_required: true,
    is_standard_field: false,
    width: 'half',
    order: 0,
    insertAfter: 'email',
    validation_rules: {
      min: 6,
    },
  },
  {
    id: 'extra_password_confirmation',
    name: 'password_confirmation',
    label: 'Confirmar Senha',
    type: 'password',
    placeholder: 'Confirme sua senha',
    is_required: true,
    is_standard_field: false,
    width: 'half',
    order: 0,
    insertAfter: 'password',
    confirm_field: 'password',
    validation_rules: {
      min: 6,
    },
  },
];
